import { createStorageStore } from './stores/storage';

export const localStorageStore = createStorageStore(localStorage);
export const sessionStorageStore = createStorageStore(sessionStorage);
